export default __webpack_public_path__ + "static/media/BeforePhoto4.30b93e86.jpg";